import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { registerServiceWorker } from './pwa';
import './styles.css';

// A deep link has been read into the initial state by now (see App.tsx), so
// drop the query string. Reloading the page should show the app, not replay
// somebody's payslip notification.
if (window.location.search) {
  history.replaceState(null, '', window.location.pathname + window.location.hash);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// A new build is applied on the next navigation rather than mid-session: the
// clock is running and reloading underneath someone mid-shift is worse than
// serving them yesterday's bundle for another minute.
registerServiceWorker((applyUpdate) => {
  window.addEventListener('pagehide', applyUpdate, { once: true });
});
